import { SaveSpecification, Specification } from '@agroone/entities'
import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { from, Observable } from 'rxjs'
import { API_URL } from '../models/environment.token'
import { NetworkService } from './network.service'
import { SharedUserService } from './shared-user.service'

@Injectable({
  providedIn: 'root',
})
export class SpecificationsService {
  private http = inject(HttpClient)
  private networkService = inject(NetworkService)
  private userService = inject(SharedUserService)

  private _apiUrl: string = inject(API_URL)

  private specificationsUrl: string = `${this._apiUrl}/specifications`

  getAllSpecForActiveRegion(): Observable<Specification[]> {
    const regionName = this.userService.currentUser?.regionName
    return from(
      this.networkService.getAllFromPaginated<Specification>(this.specificationsUrl, {
        params: regionName ? { regionName } : undefined,
      }),
    )
  }

  add(specification: SaveSpecification): Observable<Specification> {
    return this.http.post<Specification>(this.specificationsUrl, specification)
  }

  update(specification: SaveSpecification): Observable<Specification> {
    return this.http.put<Specification>(this.specificationsUrl, specification)
  }

  delete(specificationId: number) {
    return this.http.delete(`${this.specificationsUrl}/${specificationId}`)
  }
}
